// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"71c8e7ff","213":"69a5e8d8","239":"ad40150f","257":"4f5b7ced","455":"5cf95181","607":"c3f34178","664":"2bb51451","845":"c3f34178","958":"7bb9afff","988":"c3f34178"}[chunkId] + ".chunk.js";
};